'use client';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { useRouter } from 'next/navigation';
import styles from './TrackAndCalculate.module.css';
import { CitySelect } from '@/components/features/Calculator/CitySelect/CitySelect';
import { PackageSizeSelector } from '@/components/features/Calculator/PackageSelect/PackageSizeSelector';
import { ButtonFilled } from '@/components/ui/Button/ButtonFilled';
import { getSelectedCity } from '@/lib/services/cityService';
import { deliveryValidation } from '@/lib/utils/deliveryValidation';

export const CalculatorForm = () => {
    const router = useRouter();
    const { selectedCity } = useSelector((state: RootState) => state.calculatorStore);
    const [isValid] = deliveryValidation(selectedCity);
    const dispatch = useDispatch();

    const handleClick = async () => {
        await getSelectedCity(selectedCity, dispatch);
        if (isValid) {
            router.push('/calculator');
        }
    };

    return (
        <>
            <div className={styles.grid}>
                <CitySelect type="from" label="Город отправки" />
                <CitySelect type="to" label="Город назначения" />
                <div>
                    <PackageSizeSelector />
                </div>
            </div>
            <ButtonFilled full={true} onClick={handleClick}>
                Рассчитать
            </ButtonFilled>
        </>
    );
};
